export const colors = {
  background: '#021036',
  textUnselected: '#80889A',
  black: '#04102d',
  linkColor: '#117ca9'
}
